import React from "react";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";
import { RushingStats } from "../../../../types/LogTypes";
import { useRoster } from "../../../../contexts/RosterContext";
import "./../Styles/Offense.css";
import { jerseyNumberNameDisplay } from "../../../../helpers/helpers";

interface Props {
  rushingStats?: RushingStats;
}

export const Rushing: React.FC<Props> = ({ rushingStats }) => {
  const { rosterPlayers } = useRoster();

  if (!rushingStats) {
    return null;
  }

  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <Typography variant="h6">Rushing</Typography>
      </Box>
      <TableContainer>
        <Table className="stats-table">
          <TableHead>
            <TableRow>
              <TableCell className="player-name">Player</TableCell>
              <TableCell className="stat-cell">Att</TableCell>
              <TableCell className="stat-cell">Yards/Carry</TableCell>
              <TableCell className="stat-cell">Yards</TableCell>

              <TableCell className="stat-cell">TD</TableCell>
              <TableCell className="stat-cell">Fumbles</TableCell>
              <TableCell className="stat-cell"></TableCell>
              <TableCell className="stat-cell"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(rushingStats).map(([rosterId, stats]) => {
              const player = rosterPlayers.find(
                (p) => p.id === parseInt(rosterId)
              );
              return (
                <TableRow key={rosterId}>
                  <TableCell className="player-name">
                    {jerseyNumberNameDisplay(player)}
                  </TableCell>
                  <TableCell className="stat-cell">{stats.carries}</TableCell>
                  <TableCell className="stat-cell">
                    {stats.yards_per_carry.toFixed(1)}
                  </TableCell>
                  <TableCell className="stat-cell">{stats.yards}</TableCell>

                  <TableCell className="stat-cell">
                    {stats.touchdowns}
                  </TableCell>
                  <TableCell className="stat-cell">{stats.fumbles}</TableCell>
                  <TableCell className="stat-cell"></TableCell>
                  <TableCell className="stat-cell"></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
